import React from "react"

import getProfileItems from "./getProfileItems"
import InvestmentInvestor from "../InvestmentInvestor"

const LABEL_INVESTOR = "Investor"


const getItems = ({
  account,
  investment,
  openAccountDrawer,
  onAfterAccountUpdate,
  openInvestmentProfileUpdateDrawer,
  openInvestmentAccreditationUpdateModal,
}) => {
  const {
    investor,
    isFunded,
    isSigned,
    investorErrors = [],
  } = investment

  const profileItems = getProfileItems(investment, openInvestmentProfileUpdateDrawer)

  const items = [
    {
      label: LABEL_INVESTOR,
      value: (
        <InvestmentInvestor
          errors={investorErrors}
          account={account}
          onClick={openAccountDrawer}
          investor={investor}
          isFunded={isFunded}
          isSigned={isSigned}
          onAfterAccountUpdate={onAfterAccountUpdate}
          openInvestmentAccreditationUpdateModal={openInvestmentAccreditationUpdateModal}
        />
      ),
    },
    ...profileItems,
  ]

  return items
}

export default getItems
